import React, { useEffect, useState } from "react";
import dayjs, { Dayjs } from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { Container, Tab } from "./DateTabPicker.styled";
import isPropValid from "@emotion/is-prop-valid";
import { StyleSheetManager } from "styled-components";
dayjs.extend(utc);
dayjs.extend(timezone);
const userLocalTimzone = dayjs.tz.guess();

export * from "./DateTabPicker.styled";
export const DateTabPicker = ({ date, onChange }:{ date?:Dayjs, onChange?: (day:Dayjs) => any}) => {

    const [ days, setDays ] = useState<Dayjs[]>([]);
    const [ now, setNow ] = useState<Dayjs>(date || dayjs());
    
    useEffect(() => {

        const _days = [ 
            now.subtract(3, 'day'),
            now.subtract(2, 'day'),
            now.subtract(1, 'day'),
            now,
            now.add(1, 'day'),
            now.add(2, 'day'),
            now.add(3, 'day')
        ];
        setDays(_days);
        onChange && onChange(now);

    }, [ now.toISOString() ]);

    const prepateDayClickHandler = (day:Dayjs) => {
        return () => setNow(day);
    }

    return <StyleSheetManager shouldForwardProp={isPropValid}>
            <Container>
            <Tab.Arrow onClick={prepateDayClickHandler(now.subtract(7, 'day'))}>
                {'\u21E0'}
            </Tab.Arrow>
            { days.map( day => <Tab.Main onClick={prepateDayClickHandler(day)}>
                <Tab.Day>{day.format('dddd')}</Tab.Day>
                <Tab.Date>{day.format('MMM DD')}</Tab.Date>
            </Tab.Main> )}
            <Tab.Arrow onClick={prepateDayClickHandler(now.add(7, 'day'))}>
                {'\u21E2'}
            </Tab.Arrow>
        </Container>;
    </StyleSheetManager>

}

export default DateTabPicker;